/**
 * Created by Petr Kubišta on 02.01.2017.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Mobile = Lfl.Mobile || {};

    (function (Mobile, $, undefined) {
        /*
         |==============================================================================================================
         | Object definition
         |==============================================================================================================
         | Note: The object also serves as a namespace for other objects, e.g. Lfl.Mobile.Sender
         */

        var getBadgeUrl;
        var getIsLoggedInUrl;
        var getUserIdUrl;
        var getUsernameUrl;
        var refreshUnresolvedUrl = "";

        /*
         |----------------------------------------------------------------------------------------
         | Requested values
         |------------------
         | Values that are requested from the mobile application and retrieved asynchronously. */
        /**
         * @memberOf Lfl.Mobile
         * @type {string}
         */
        Mobile.CURRENT_INSTALLATION_URL_UNAVAILABLE = 'InstallationUrlUnavailable';
        /**
         * @memberOf Lfl.Mobile
         * @type {string}
         */
        Mobile.HAS_USED_CURRENT_INSTALLATION_UNAVAILABLE = 'HasUsedCurrentInstallationUnavailable';

        // The promise IDs. Used to make sure the code resolving the promise has been given the rights to do so.
        var CURRENT_INSTALLATION_URL_PROMISE_ID = "currentInstallationUrl" + '@' + Math.random();
        var HAS_USED_CURRENT_INSTALLATION_PROMISE_ID = "hasUsedCurrentInstallation" + '@' + Math.random();

        var currentInstallationUrlPromiseDeferred;
        var hasUsedCurrentInstallationPromiseDeferred;

        /*
         |---------------------------------------------------------------------------------------------------------------
         | Public methods
         |---------------------------------------------------------------------------------------------------------------
         */

        /**
         * @param parameters
         * @param parameters.getBadgeUrl
         * @param parameters.getIsLoggedInUrl
         * @param parameters.getUserIdUrl
         * @param parameters.getUsernameUrl
         * @memberOf Lfl.Mobile
         */
        Mobile.init = function (parameters) {
            getBadgeUrl = parameters.getBadgeUrl;
            getIsLoggedInUrl = parameters.getIsLoggedInUrl;
            getUserIdUrl = parameters.getUserIdUrl;
            getUsernameUrl = parameters.getUsernameUrl;
        };

        /**
         * @param parameters
         * @param parameters.refreshUnresolvedUrl
         * @memberOf Lfl.Mobile
         */
        Mobile.initForKindergarten = function (parameters) {
            refreshUnresolvedUrl = parameters.refreshUnresolvedUrl;
        };

        /**
         * @deprecated Used in clm version 1.2.2. Use getCurrentUserId od saveUsername directly!
         *
         * @memberOf Lfl.Mobile
         */
        Mobile.getCurrentUser = function () {
            Lfl.Mobile.getCurrentUserId();
            Lfl.Mobile.saveUsername();
        };

        /**
         * @memberOf Lfl.Mobile
         */
        Mobile.getCurrentUserId = function () {
            $.ajax({
                url: getUserIdUrl,
                type: "get",
                success: function (data) {
                    Lfl.Mobile.Sender.onUserReturned(data.id);
                },
                failure: function (data) {
                    console.error("Unable to retrieve user id");
                    console.log("Response was: ");
                    console.log(data);
                }
            });
            return "ajax called for user id";
        };

        /**
         * @memberOf Lfl.Mobile
         */
        Mobile.saveUsername = function () {
            $.ajax({
                url: getUsernameUrl,
                type: "get",
                success: function (data) {
                    Lfl.Mobile.Sender.saveUsername(data.username);
                },
                failure: function (data) {
                    console.error("Unable to retrieve username");
                    console.log("Response was: ");
                    console.log(data);
                }
            });
        };

        /**
         * @memberOf Lfl.Mobile
         */
        Mobile.refreshUnresolved = function (contentId, contentTag) {
            if (typeof refreshUnresolvedUrl === 'undefined') {
                throw new Error("This object was not properly initialized for kindergarten and cannot be used in this state. Missing refreshUnresolvedUrl value.");
            }
            $.ajax({
                type: 'post',
                url: refreshUnresolvedUrl,
                dataType: 'json',
                data: {
                    content_id: contentId,
                    content_tag: contentTag
                },
                success: function (data) {
                    // Currently unused
                    // Lfl.Mobile.Sender.onAjaxSuccess(data.unreadMessagesCount);
                    $("#unread-messages-count").text(data.unreadMessagesCount);
                    $("#unresolved-alerts-count").text(data.unresolvedAlertsCount);

                },
                error: function (x, errorText, y) {
                    Lfl.Mobile.Sender.onAjaxFailure(x, errorText, y);
                }

            })
        };

        Mobile.injectUsername = function (username) {
            var items = document.getElementsByName('email');
            if (items.length > 0) {
                items.item(0).value = username;
            }
        };

        Mobile.closeModal = function () {
            // TODO REVIEW is this the correct way to close a modal? Should probably be safer somehow.
            // Also, no idea why simpleModal is unknown, but it works, unlike $.modal.close();
            $.simpleModal.close();
            Lfl.Mobile.Sender.modalClosePassed();
        };

        Mobile.closePhotoswipe = function () {
            var gallery = Lfl.Fist.PhotoswipeInitializer.getGallery();
            // When photoswipe is currently open, append new items
            if (typeof gallery !== 'undefined' && gallery !== null) {
                gallery.pswp.close();
            }
        };

        Mobile.getBadge = function () {
            $.ajax({
                url: getBadgeUrl,
                type: "get",
                success: function (data) {
                    Lfl.Mobile.Sender.setBadgeCount(data.badge);
                },
                failure: function (data) {
                    console.error("Unable to retrieve badge");
                    console.log("Response was: ");
                    console.log(data);
                }
            });
        };

        Mobile.isLoggedIn = function () {
            $.ajax({
                url: getIsLoggedInUrl,
                type: "get",
                success: function (data) {
                    if (data.loggedIn) {
                        Lfl.Mobile.Sender.onLoggedIn();
                    }
                },
                failure: function () {
                    console.error("Unable to ascertain logged in status");
                }
            });
        };

        /*
         |----------------------------------------------------------------------------------------
         | Requested values
         |------------------ */

        // Note: The promiseOf prefix should generally be avoided.
        //       We would prefer to not mix sync and async code in one interface, but since we are
        //         forced to retrieve the values asynchronously, we use the prefix for distinction.

        /**
         *
         * @returns {Promise}
         * @memberOf Lfl.Mobile
         */
        Mobile.promiseCurrentInstallationUrl = function () {
            requestCurrentInstallationUrl();

            return currentInstallationUrlPromiseDeferred.promise;
        };

        /**
         *
         * @returns {Promise}
         * @memberOf Lfl.Mobile
         */
        Mobile.promiseHasUsedCurrentInstallation = function () {
            requestHasUsedCurrentInstallationUrl();

            return hasUsedCurrentInstallationPromiseDeferred.promise;
        };

        /*
         |-------------------------------------------------------------------------
         | Return values from mobile application
         |---------------------------------------
         | Those methods get called when the result is available.*/
        Mobile.resolveCurrentInstallationUrl = function (promiseId, installationUrl) {
            if(promiseId !== CURRENT_INSTALLATION_URL_PROMISE_ID) {
                throw new Error("Promise ID does not match.");
            }
            currentInstallationUrlPromiseDeferred.resolve(installationUrl);
        };

        Mobile.resolveHasUsedCurrentInstallation = function (promiseId, value) {
            if(promiseId !== HAS_USED_CURRENT_INSTALLATION_PROMISE_ID) {
                throw new Error("Promise ID does not match.");
            }
            hasUsedCurrentInstallationPromiseDeferred.resolve(value);
        };

        /*
         |-----------------------------------------------------------------------------------------------------------
         | Private methods
         |-----------------------------------------------------------------------------------------------------------
         */

        function initPromises() {
            currentInstallationUrlPromiseDeferred = deferPromise();

            hasUsedCurrentInstallationPromiseDeferred = deferPromise();

            // Note: potential timeouts are to be defined by the client code.
        }

        // See: GoToDemo::InstallationMechanisms::MobileJs::Defer
        function deferPromise() {
            var deferred = {
                promise: null,
                resolve: null,
                reject: null
            };

            deferred.promise = new Promise(function (resolve, reject) {
                deferred.resolve = resolve;
                deferred.reject = reject;
            });

            return deferred;
        }

        function requestCurrentInstallationUrl() {
            Lfl.Mobile.Sender.requestCurrentInstallationUrl(CURRENT_INSTALLATION_URL_PROMISE_ID);
        }

        function requestHasUsedCurrentInstallationUrl() {
            Lfl.Mobile.Sender.requestHasUsedCurrentInstallation(HAS_USED_CURRENT_INSTALLATION_PROMISE_ID);
        }

        /*
         |-------------------------------------------------------------------------
         | Internal init */

        initPromises();

    }(Lfl.Mobile, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));

//# sourceMappingURL=mobile.js.map
